module.exports = __webpack_public_path__ + "img/plus2.594a6041.svg";